var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { display } from 'styled-system';
import { FlexJustifyContent, Grid, GridItem, GridItemBorder, } from '../../common/components/Grid';
import { Text } from '../../common/components/Text';
import { useLocalization } from '../../common/providers/LocaleProvider';
import iconsByLocale from './iconsByLocale';
import { LazyImage } from '../../common/components/LazyImage';
import { placeholderThumbnail } from '../../common/utils/placeholderThumbnail';
var TrustIconGridItem = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var TrustIconContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 300px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 300px;\n"])));
var TrustIconLink = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 0;\n"], ["\n  font-size: 0;\n"])));
var Image = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), display);
Image.defaultProps = {
    display: 'block',
};
var TrustIconImg = function (props) { return (React.createElement(LazyImage, { x1: props.src }, function (_a) {
    var loaded = _a.loaded, image = _a.image, thumbnail = _a.thumbnail, innerRef = _a.innerRef;
    return (React.createElement(Image, { alt: props.alt, ref: innerRef, src: loaded ? image : placeholderThumbnail(props.width, props.height), style: {
            maxWidth: props.width,
            maxHeight: props.height,
        } }));
})); };
export var TrustIcon = function (_a) {
    var image = _a.image, link = _a.link, children = _a.children, notLast = _a.notLast, testid = _a.testid;
    return (React.createElement(TrustIconGridItem, { as: GridItem, w: [1, 4 / 8, 5 / 12], pb: notLast ? [3, 0] : 0, "data-testid": testid },
        React.createElement(TrustIconContent, null,
            link ? (React.createElement(TrustIconLink, __assign({}, link),
                React.createElement(TrustIconImg, __assign({}, image)))) : (React.createElement(TrustIconImg, __assign({}, image))),
            children && (React.createElement(Text, { ml: 2, lineHeight: 2 }, children)))));
};
TrustIcon.propTypes = {
    image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        alt: PropTypes.string,
    }),
    link: PropTypes.shape({
        href: PropTypes.string.isRequired,
        target: PropTypes.string,
        rel: PropTypes.string,
    }),
    children: PropTypes.node,
    notLast: PropTypes.bool,
    testid: PropTypes.string,
};
var TrustIcons = function (_a) {
    var __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
    var l10n = useLocalization();
    var legalText = l10n.replace.t('h24_footer_legal_sentence', {
        h24_currency: l10n.t('h24_currency'),
    });
    var icons = (iconsByLocale[l10n.locale] || []).map(function (icon) { return ({
        image: __assign(__assign({}, icon.image), { src: /^https?:\/\//.test(icon.image.src)
                ? icon.image.src
                : l10n.t(icon.image.src), alt: icon.image.alt ? l10n.t(icon.image.alt) : '' }),
        link: __assign(__assign({}, icon.link), { href: l10n.t(icon.link.href) }),
        Content: icon.Content,
    }); });
    return (React.createElement(React.Fragment, null,
        icons && icons.length > 0 && (React.createElement(Grid, { justifyContent: FlexJustifyContent.CENTER, py: 4, legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width }, icons.map(function (icon, index) { return (React.createElement(TrustIcon, { key: index, image: icon.image, link: icon.link, notLast: index !== icons.length - 1, testid: "trusted-icon-" + index }, icon.Content && React.createElement(icon.Content, null))); }))),
        React.createElement(Grid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
            React.createElement(GridItemBorder, null),
            React.createElement(GridItem, { py: 3, "data-testid": "legal-text" },
                React.createElement(Text, { textAlign: "center", lineHeight: 2 }, legalText)))));
};
TrustIcons.propTypes = {
    __legacy_shop_reboot_max_width: PropTypes.bool,
};
TrustIcons.defaultProps = {
    __legacy_shop_reboot_max_width: true,
};
export default TrustIcons;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
